import { createSelector } from 'reselect'
import _ from 'lodash';
import { todayID, weekID, lastWeekID, daysInThisWeek, toArray } from '../../components/assets/util';

const f_currentCustomerId = state => state.currentCustomerId;
const f_loggedInUserId = state => state.loggedInUserId;
const f_data = state => state.firestore.data;
const f_todayHappinessUnsaved = state => state.general.todayHappiness;

export const loggedInUser = createSelector(
    f_currentCustomerId, f_loggedInUserId, f_data,
    (currentCustomerId, loggedInUserId, data) => _.get(data, `customers[${currentCustomerId}].people[${loggedInUserId}]`)
  );

export const randomQuote = createSelector(
    f_data,
    data => {
      if(!data.quotes)
        return null;
      let toArray = Object.keys(data.quotes).map(key => data.quotes[key]);
      return toArray.length > 0 && toArray[Math.floor(Math.random() * toArray.length)]
    }
  );

export const todayHappiness = createSelector(
  loggedInUser, f_todayHappinessUnsaved,
  (loggedInUser, todayHappinessUnsaved) => ({
    ..._.get(loggedInUser, `happiness[${todayID}]`),
    ...todayHappinessUnsaved
  })
);

export const shortcuts = createSelector(
  loggedInUser,
  user => toArray(user.shortcuts)
);

export const highFives = createSelector(
  loggedInUser,
  user => user && toArray(user.highFives)
);

export const newHighFivesCount = createSelector(
  highFives,
  highFives => highFives && highFives.filter(highFive => highFive.read !== true ).length
);
